// !!!! - DO NOT MODIFY - !!!!
// THIS FILE IS DEPLOYED AUTOMATICALLY BY MATTv2.
//
//  Deployment info:
//    Updated at:     2025-11-07T15:16:48+00:00
//    Cause:          Manual deployment.
//    Deployment ID:  190344
//    Project:        617
//    Environment:    7626 - master
//    MD5:            fc19f8218ee423d48502dad6c3ac2595
//    Signature:      eyJpdiI6ImQ3dzcxUzZIeEM1VUNhcFlqVmQ5cWc9PSIsInZhbHVlIjoiRmhHS3oxa2trMGhYYUtFcit2RTJWSndhUEtjZGRNd05QN0loRGJzUHd1bFRPSHZsVENLUkNqQnJKam5JMDlmWU15Q1pTSHJQN2l4WXpZMUF6S1U0aUJBQzFScFpMQzU0anpxa2l1MFBkYmUyMDhCeGg0RFhvUGQ0MjV5b0RFeEFaTnRpQjAyQWh2ZWlcL1FMQjhEZHdNRWxZbzlPMWpTR0N3WHdXTEFiNFNXaCt2ZG1WYXBsZ05XblZJeHkzZGdMa1VVK00rNVJUUWZMcGg5WW1HQWlOSzhPb29kZDgwMTN5d3NZVHhsZm12VnhVWmZ5ZzM0QWlUaTF5M01EazFPME1jelJKeFVOcVdJMkllTmhkRlJzb3B5SGNkVkFMVXIzU05vMzFoaFlVQmtnRDBPNVV0WVRXaUJDM2xYUUJxa2JHcXdwRWdKUnpHTklyK2FVOFRtbXlMdjNjZUZKVUVYdlQ3N1RzV1wvdUNIMmh4a2k1Z2Y5d05SNkluQWtUSVprMmxWTkpsVnNGcFlXK3ZBcmcrR0NnR3FmOGZ2UmlaYTNKa2lSd1A3cUplcTV3PSIsIm1hYyI6IjgxNTU1N2E4YjRmNzdhNzRjZjU3ZGM5YjhlYmYzM2I5MWFjNTVkZTFhNzE2NzQxOGMxNmUwOTk0YTYyZTRhYWIifQ==
const termsCheckbox = document.getElementById('terms');
const subscribeButton = document.getElementById('Subscribe');

if (termsCheckbox && subscribeButton) {
termsCheckbox.addEventListener('change', function() {
  subscribeButton.disabled = !this.checked;
});
}